import React from 'react';
import { cn } from '@/shadcn/lib/utils';

interface SectionHeaderProps extends React.HTMLAttributes<HTMLHeadingElement> {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
  level?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

const SectionHeader = React.forwardRef<HTMLHeadingElement, SectionHeaderProps>(
  ({ title, subtitle, icon, actions, level = 'h2', className, ...props }, ref) => {
    const Component = level;

    return (
      <div className={cn('flex items-center justify-between', className)}>
        <div className="flex items-center gap-2">
          {icon}
          <div>
            <Component
              ref={ref}
              className={cn(
                // Default styles based on heading level
                level === 'h1' && 'text-3xl font-bold',
                level === 'h2' && 'text-xl font-semibold',
                level === 'h3' && 'text-lg font-medium',
                level === 'h4' && 'text-base font-medium',
                level === 'h5' && 'text-sm font-medium',
                level === 'h6' && 'text-xs font-medium',
              )}
              {...props}
            >
              {title}
            </Component>
            {subtitle && (
              <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>
            )}
          </div>
        </div>
        {actions && <div>{actions}</div>}
      </div>
    );
  }
);

SectionHeader.displayName = 'SectionHeader';

export { SectionHeader };
